import React from "react";
import { Modal, Button, Typography } from "antd";
import { UndoOutlined, WarningOutlined } from "@ant-design/icons";

interface Props {
  open: boolean;
  count: number;
  hasFilter: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ModalDesfazerConciliacao: React.FC<Props> = ({
  open,
  count,
  hasFilter,
  isLoading,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      open={open}
      title={
        <span>
          <UndoOutlined style={{ marginRight: 8, color: "#e74c3c" }} />
          Desfazer Conciliação Manual
        </span>
      }
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancelar
        </Button>,
        hasFilter ? (
          <Button
            key="confirm"
            danger
            type="primary"
            loading={isLoading}
            onClick={onConfirm}
          >
            Desfazer Conciliação
          </Button>
        ) : null,
      ]}
      width={480}
    >
      {!hasFilter ? (
        <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
          <WarningOutlined style={{ fontSize: 22, color: "#f39c12", marginTop: 2 }} />
          <Typography.Text>
            Nenhum filtro ativo. Aplique ao menos um filtro (data, adquirente,
            empresa, etc.) antes de desfazer a conciliação, para evitar
            alterações em massa nos dados.
          </Typography.Text>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Typography.Text>
            Esta ação irá desfazer a conciliação manual de{" "}
            <strong>{count} registro(s)</strong> visíveis no filtro atual.
          </Typography.Text>
          <div
            style={{
              background: "#fff7e6",
              border: "1px solid #ffd591",
              borderRadius: 6,
              padding: "10px 14px",
            }}
          >
            <Typography.Text strong>Alterações que serão aplicadas:</Typography.Text>
            <ul style={{ margin: "8px 0 0", paddingLeft: 20 }}>
              <li>
                Status de Pagamento → <strong>Pagamento Previsto</strong>
              </li>
              <li>
                Status de Conciliação → <strong>Não Conciliado</strong>
              </li>
              <li>
                Justificativa → <strong>(vazia)</strong>
              </li>
            </ul>
          </div>
          <Typography.Text type="warning">
            <WarningOutlined style={{ marginRight: 6 }} />
            Esta ação não pode ser desfeita. Deseja continuar?
          </Typography.Text>
        </div>
      )}
    </Modal>
  );
};

export default ModalDesfazerConciliacao;
